import React, { useEffect } from 'react';
import '../assets/CardGrid.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import mangadewadi from '../assets/imgs/mangadewadi.webp';
import saswad from '../assets/imgs/saswadi.webp';
import vadgaon from '../assets/imgs/vadgaon.webp';
import lonavala from '../assets/imgs/lonavala.webp';
import hingane from '../assets/imgs/hingane.webp';
import ambegaon from '../assets/imgs/ambegaaon.webp';
import gujarwadi from '../assets/imgs/gujarwadi.webp';
import wai from '../assets/imgs/wai.webp';
import Mahabaleshwar from '../assets/imgs/mahabaleshwar.webp';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Whatsapp from './Whatsapp';

function Projects() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
        });
    }, []);

    const projectSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    const projects = [
        {
            title: 'Hingane',
            location: 'Sinhgad road, Pune',
            type: 'Residential apartment',
            image: hingane
        },
        {
            title: 'Mangadewadi',
            location: 'Pune',
            type: 'Residential apartment',
            image: mangadewadi
        },
        {
            title: 'Saswad Hivare',
            location: 'Pune',
            type: 'Bungalow Plotting',
            image: saswad
        },
        {
            title: 'Ambegaon',
            location: 'Pune',
            type: 'Residential apartment',
            image: ambegaon
        },
        {
            title: 'Gujarwadi',
            location: 'Pune',
            type: 'Residential apartment',
            image: gujarwadi
        },
        {
            title: 'Vadgaon',
            location: 'Pune',
            type: 'Plotting Project',
            image: vadgaon
        },
        {
            title: 'Wai',
            location: 'Satara',
            type: 'Plotting Project',
            image: wai
        },
        {
            title: 'Lonavala',
            location: 'Pune',
            type: 'Farmhouse Plotting',
            image: lonavala
        },
        {
            title: 'New Mahabaleshwar',
            location: 'Pune',
            type: 'Plotting Project',
            image: Mahabaleshwar
        },
    ];

    return (
        <>
            <div className="project-container" data-aos="fade-up">
                <h2 className="project-head">
                    Completed <span> Projects </span>
                </h2>

                <Slider {...projectSettings} className="project-carousel ">
                    {projects.map((project, index) => (
                        <div className="project " key={index} data-aos="fade-up">
                            <div className="project-image">
                                {/* Uncomment the line below if using images */}
                                <img src={project.image} loading="lazy" alt={project.title} />
                            </div>
                            <div className="project-info">
                                <h2>{project.title}</h2>
                                <p>{project.location}</p>
                                <p>{project.type}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            <Whatsapp />

        </>
    );
}

export default Projects;
